import { Component, EventEmitter, inject, Input, OnInit, Output, Signal } from '@angular/core';
import {
  OpinionOnIssuingADecisionInvestorItemForm
} from '../../forms/opinion-on-issuing-a-decision-investor-item.form';
import { ApplicantAppEntityApplicantWrite } from '../../../../../../../../openapi';
import { Store } from '@ngrx/store';
import { UserDetails } from '../../../../../../../../store/reducers/user-details.reducer';
import { selectUser } from '../../../../../../../../store/selectors/user-details.selectors';
import { SessionService } from '../../../../../../../../services/ssession.service';
import { ReactiveFormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { NgxMaskDirective } from 'ngx-mask';
import {
  ValidationErrorsComponent
} from '../../../../../../../../common/validation-errors/validation-errors.component';

@Component({
  selector: 'app-opinion-on-issuing-a-decision-investor-natural-person-form',
  standalone: true,
  imports: [
    ReactiveFormsModule,
    CommonModule,
    NgxMaskDirective,
    ValidationErrorsComponent
  ],
  templateUrl: './opinion-on-issuing-a-decision-investor-natural-person-form.component.html'
})
export class OpinionOnIssuingADecisionInvestorNaturalPersonFormComponent implements OnInit {

  private entityType = '14115421-88f2-431a-8310-203c68180b33';

  private store$: Store = inject(Store);

  @Input()
  public edit = false;

  public user: Signal<UserDetails | null> = this.store$.selectSignal(selectUser);

  @Input()
  public form: OpinionOnIssuingADecisionInvestorItemForm | undefined;

  @Input()
  public showCancel: boolean = true;

  @Output()
  public onCancel = new EventEmitter();

  @Output()
  public onSubmit = new EventEmitter<ApplicantAppEntityApplicantWrite>();

  public onPastDataFromPortal(): void {
    this.form?.readApplicantDataFromPortal(this.user());
  }

  public onPastDataFromLoginGov(): void {
    this.form?.readApplicantDataFromGovPl(SessionService.GetTokenData());
  }

  public submit(): void {
    if (this.form?.valid) {
      this.onSubmit.emit(this.form.toWriteModel());
      this.form.reset({ applicantType: this.entityType });
    } else {
      this.form?.markAllAsTouched();
    }
  }

  public cancel(): void {
    this.onCancel.emit();
    this.form?.reset({ applicantType: this.entityType });
  }

  public ngOnInit(): void {
    this.form?.applicantType.setValue(this.entityType);

    this.form?.name.disable();
    this.form?.nip?.disable();

    this.form?.firstName.enable();
    this.form?.lastName.enable();
  }

}
